import { Button } from '@/components/ui/button';
import { useDealContext } from '@/contexts/deal-provider';
import { useDealByShortId } from '@/hooks/use-deals-selectors';
import { cn } from '@/lib/utils';
import type { Deal } from '@/models/registry';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';
import { getDeliveryQueueOptionsMap } from './delivery-queue-selector';
import getDeliveryQueueHealthClasses from './get-delivery-queue-health-classes';

const DeliveryQueueBadge = ({
  pickupDate,
  delivery_date,
  date_added,
  hideCopy,
  useAbbreviation,
  className,
}: {
  pickupDate: Deal['pickup_date'];
  delivery_date: Deal['delivery_date'];
  date_added: Deal['date_added_to_customer_delivery_queue'];
  hideCopy?: boolean;
  useAbbreviation?: boolean;
  className?: string;
}) => {
  const { currentShortId } = useDealContext();
  const deal = useDealByShortId(currentShortId);
  const deliveryQueueHealthClasses = useMemo(
    () =>
      getDeliveryQueueHealthClasses({
        pickupDateOrDeliveryDate: pickupDate || delivery_date,
        deal: deal!,
      }),
    [delivery_date, deal],
  );

  const DELIVERY_QUEUE_OPTIONS_MAP = useMemo(
    () => getDeliveryQueueOptionsMap(deliveryQueueHealthClasses),
    [deliveryQueueHealthClasses],
  );

  const isAddedToDeliveryQueue = !isEmpty(date_added);

  return (
    <Button variant="ghost" className={cn('p-1 h-fit', className)}>
      {isAddedToDeliveryQueue === true &&
        DELIVERY_QUEUE_OPTIONS_MAP.find((option) => option.booleanValue)?.icon}

      {isAddedToDeliveryQueue === false &&
        DELIVERY_QUEUE_OPTIONS_MAP.find((option) => !option.booleanValue)?.icon}
      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {useAbbreviation
            ? DELIVERY_QUEUE_OPTIONS_MAP.find(
                (option) => option.booleanValue === isAddedToDeliveryQueue,
              )?.abbreviation
            : DELIVERY_QUEUE_OPTIONS_MAP.find(
                (option) => option.booleanValue === isAddedToDeliveryQueue,
              )?.label}
        </p>
      )}
    </Button>
  );
};

export default DeliveryQueueBadge;
